import script from "./accountIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./accountIndex.vue?vue&type=script&setup=true&lang=js"

import "./accountIndex.vue?vue&type=style&index=0&id=4fa2c49e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4fa2c49e"]])

export default __exports__